import {createSlice} from "@reduxjs/toolkit";
import {uploadFiles} from "@/store/file/action";

const initialState = {
	state: {
    file: null
  },
  loading: true,
  error: ''
} as BaseState<FileState>

const slice = createSlice({
  name: 'fileSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(uploadFiles.pending, (state) => ({
        ...state,
        loading: true
      })
    )
    builder.addCase(uploadFiles.fulfilled, (state) => ({
      ...state,
			loading: false,
				error: ''
      })
    )
    builder.addCase(uploadFiles.rejected, (state) => ({
        ...state,
        loading: true,
        error: 'Failed to upload file'
      })
    )
  }
})

export default slice
